if (!customElements.get('desktop-mega-menu-hover')) {
  class DesktopMegaMenuHover extends HTMLElement {
    constructor() {
      super();
      this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
      this.details = Array.from(this.querySelectorAll('.nav-item--has-children'));
      this.onDesktopChange = this.onDesktopChange.bind(this);
    }

    connectedCallback() {
      if (!this.details.length) return;

      this.bindDesktopEvents();

      if (this.desktopMediaQuery.addEventListener) {
        this.desktopMediaQuery.addEventListener('change', this.onDesktopChange);
      } else {
        this.desktopMediaQuery.addListener(this.onDesktopChange);
      }
    }

    disconnectedCallback() {
      this.unbindDesktopEvents();

      if (this.desktopMediaQuery.removeEventListener) {
        this.desktopMediaQuery.removeEventListener('change', this.onDesktopChange);
      } else {
        this.desktopMediaQuery.removeListener(this.onDesktopChange);
      }
    }

    onDesktopChange() {
      this.closeAllMenus();

      this.unbindDesktopEvents();
      this.bindDesktopEvents();
    }

    bindDesktopEvents() {
      if (!this.desktopMediaQuery.matches) return;

      this.details.forEach((detail) => {
        const summary = detail.querySelector('summary');
        if (!summary) return;

        const onMouseEnter = () => this.openMenu(detail);
        const onMouseLeave = () => this.closeMenu(detail);
        const onFocusIn = () => this.openMenu(detail);
        const onSummaryClick = (event) => {
          if (!this.desktopMediaQuery.matches) return;
          event.preventDefault();
          this.openMenu(detail);
        };

        detail.__hoverHandlers = { onMouseEnter, onMouseLeave, onFocusIn, onSummaryClick };

        detail.addEventListener('mouseenter', onMouseEnter);
        detail.addEventListener('mouseleave', onMouseLeave);
        detail.addEventListener('focusin', onFocusIn);
        summary.addEventListener('click', onSummaryClick);
      });
    }

    unbindDesktopEvents() {
      this.details.forEach((detail) => {
        const summary = detail.querySelector('summary');
        const handlers = detail.__hoverHandlers;
        if (!summary || !handlers) return;

        detail.removeEventListener('mouseenter', handlers.onMouseEnter);
        detail.removeEventListener('mouseleave', handlers.onMouseLeave);
        detail.removeEventListener('focusin', handlers.onFocusIn);
        summary.removeEventListener('click', handlers.onSummaryClick);
        delete detail.__hoverHandlers;
      });
    }

    openMenu(activeDetail) {
      if (!this.desktopMediaQuery.matches) return;

      this.details.forEach((detail) => {
        if (detail === activeDetail) {
          detail.setAttribute('open', '');
          detail.querySelector('summary')?.setAttribute('aria-expanded', 'true');
        } else {
          this.closeMenu(detail);
        }
      });
    }

    closeMenu(detail) {
      detail.removeAttribute('open');
      detail.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    }

    closeAllMenus() {
      this.details.forEach((detail) => this.closeMenu(detail));
    }
  }

  customElements.define('desktop-mega-menu-hover', DesktopMegaMenuHover);
}

// Drawer close button inside the drawer panel
document.addEventListener('DOMContentLoaded', function () {
  var drawerCloseBtn = document.querySelector('.ch-drawer-close-btn');
  if (drawerCloseBtn) {
    drawerCloseBtn.addEventListener('click', function () {
      var headerDrawer = document.querySelector('header-drawer');
      var details = document.getElementById('Details-menu-drawer-container');
      var summary = details ? details.querySelector('summary') : null;
      if (headerDrawer && typeof headerDrawer.closeMenuDrawer === 'function') {
        // Pass an event + focus element so Dawn runs its full cleanup
        // (removes overflow-hidden-* from body, closes submenus, releases focus trap).
        headerDrawer.closeMenuDrawer(new Event('click'), summary);
      } else if (details) {
        details.removeAttribute('open');
      }
      // Safety net in case the custom element isn't upgraded yet.
      document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
    });
  }
});

// Mobile search — dedicated full-screen overlay (fixed bar + predictive results)
document.addEventListener('DOMContentLoaded', function () {
  var mobileSearchBtn = document.getElementById('ChMobileSearch');
  var headerSearch = document.querySelector('.header-search');
  if (!mobileSearchBtn || !headerSearch) return;

  var input = headerSearch.querySelector('.ch-search__input');
  var closeBtn = document.getElementById('ChMobileSearchClose');

  function openSearch() {
    headerSearch.classList.add('ch-mobile-search-open');
    document.body.classList.add('overflow-hidden-mobile');
    if (input) {
      // Focus after paint so the mobile keyboard opens reliably
      requestAnimationFrame(function () { input.focus(); });
    }
  }

  function closeSearch() {
    headerSearch.classList.remove('ch-mobile-search-open');
    document.body.classList.remove('overflow-hidden-mobile');
    if (input) {
      input.value = '';
      input.blur();
      // Let the predictive search clear its results
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  mobileSearchBtn.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && headerSearch.classList.contains('ch-mobile-search-open')) {
      closeSearch();
    }
  });
});

// Desktop sticky emergency bar offset for the announcement bar
document.addEventListener('DOMContentLoaded', function () {
  var desktopEmergencyBar = document.querySelector('.emergency-bar-container--desktop .emergency-bar');
  var desktopMedia = window.matchMedia('(min-width: 990px)');

  function updateEmergencyOffset() {
    if (desktopEmergencyBar && desktopMedia.matches) {
      document.documentElement.style.setProperty('--ch-emergency-height', desktopEmergencyBar.offsetHeight + 'px');
    } else {
      document.documentElement.style.setProperty('--ch-emergency-height', '0px');
    }
  }

  updateEmergencyOffset();
  window.addEventListener('resize', updateEmergencyOffset);

  if (typeof ResizeObserver !== 'undefined' && desktopEmergencyBar) {
    var emergencyObserver = new ResizeObserver(updateEmergencyOffset);
    emergencyObserver.observe(desktopEmergencyBar);
  }
});
